import React from 'react';
import MidiRemoveBindingAction from '../../actions/MidiRemoveBindingAction';
import PropTypes from 'prop-types';
export default class MidiItem extends React.Component {
	static propTypes = {
		name: PropTypes.string
	};

	constructor(props) {
		super(props);
	}

	static contextTypes = {
		executeAction: PropTypes.func.isRequired
	};

	_makePathPretty(path) {
		path = path.split("_");

		var nicePath = "";
		var paramName = "";

		if(path[0] == "CHANNEL") {
			nicePath += "Channel " + (path[1]*1+1);
			if(path[2] == "INSTRUMENT") {
				nicePath += " Inst.";
				paramName = path[4];
			} else if (path[2] == "EFFECT") {
				nicePath += " FX " + (path[3]);
				paramName = path[5];
			} else if(path[2] == "PARAM") {
				nicePath += " Mixer";
				paramName = path[3];
			}
		}
		return {
			path: nicePath,
			param: paramName
		};
	}

	_getShortType(type) {
		var shortTypes = {
			"control-change" : "CC"
		};

		return shortTypes[type] || type;
	}


	render() {

		var path = this._makePathPretty(this.props.path);

		return (
			<li className="midi-item">
				<div className="text">
					<p>C{this.props.channel} {this._getShortType(this.props.type)}{this.props.number}</p>
					<p>{path.path} {path.param}</p>
				</div>
				<span className="use" onClick={this.handleClickRemoveBinding.bind(this)}>Delete</span>
			</li>
		);
	}

	handleClickRemoveBinding(event) {
		event.preventDefault();

		this.context.executeAction(MidiRemoveBindingAction, {
			path: this.props.path,
			midi_path: this.props.midi_path
		});

	}
}
